import classnames from "classnames";
import moment from "moment";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { getVideoQueue, retryVideoQueueItem } from "../../actions/videoManager";
import { BreadCrumb } from "../../components/breadcrumb";

const videoQueueRecordStatus = {
  0: "None",
  1: "Waiting",
  2: "In-Progress",
  3: "Deleting",
  4: "Completed",
  5: "Failed",
};

const { SearchBar } = Search;

class VideoManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "All",
      loading: false,
      contentData: [],
      cdInProgress: [],
      cdWaiting: [],
      cdFailed: [],
      cdCompleted: [],
      cdDeleting: [],
    };
  }

  items = [{ title: "Video Manager", to: "/video-manager" }];

  componentDidMount() {
    this.props.getVideoQueue();
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.data.videoQueue !== nextProps.data.videoQueue) {
      let cdWaiting = nextProps.data.videoQueue.filter((vq) => vq.status === "Waiting");
      let cdInProgress = nextProps.data.videoQueue.filter((vq) => vq.status === "In-Progress");
      let cdFailed = nextProps.data.videoQueue.filter((vq) => vq.status === "Failed");
      let cdCompleted = nextProps.data.videoQueue.filter((vq) => vq.status === "Completed");
      let cdDeleting = nextProps.data.videoQueue.filter((vq) => vq.status === "Deleting");

      this.setState({
        contentData: nextProps.data.videoQueue,
        cdWaiting: cdWaiting,
        cdInProgress: cdInProgress,
        cdFailed: cdFailed,
        cdCompleted: cdCompleted,
        cdDeleting: cdDeleting,
      });
      NotificationManager.success(`Video Manager queue data refreshed successfully`);
    }

    if (this.props.data.videoQueueError !== nextProps.data.videoQueueError) {
      if (
        nextProps.data.videoQueueError &&
        nextProps.data.videoQueueError.details &&
        nextProps.data.videoQueueError.details.message
      ) {
        NotificationManager.error(nextProps.data.videoQueueError.details.message);
      }
    }

    if (this.props.data.retryVideoQueueItem !== nextProps.data.retryVideoQueueItem) {
      this.props.getVideoQueue();
    }

    if (this.props.data.retryVideoQueueItemError !== nextProps.data.retryVideoQueueItemError) {
      if (
        nextProps.data.retryVideoQueueItemError &&
        nextProps.data.retryVideoQueueItemError.details &&
        nextProps.data.retryVideoQueueItemError.details.message
      ) {
        NotificationManager.error(nextProps.data.retryVideoQueueItemError.details.message);
      }
    }
  };

  buttonFormatter(cell, row) {
    return (
      <div>
        <a
          className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="Retry"
          onClick={(e) => this.retryQueueItem(e, row)}
        >
          <i className="fa fa-retweet"></i>
        </a>
      </div>
    );
  }

  tableHeaderColumnData = [
    {
      dataField: "MedicalRecord.pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.MedicalRecord.avatar_path +
                "/" +
                row.MedicalRecord.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Video Upload Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            className={
              "m-badge mx-auto my-0 px-2 " +
              (cell === "None"
                ? "m-badge--metal"
                : cell === "Waiting"
                ? "m-badge--wide"
                : cell === "In-Progress"
                ? "m-badge--warning"
                : cell === "Deleting"
                ? "m-badge--warning"
                : cell === "Completed"
                ? "m-badge--success"
                : cell === "Failed"
                ? "m-badge--danger"
                : " m-badge--metal")
            }
          >
            <strong>{cell}</strong>
          </span>
        );
      },
      filterValue: (cell, row) => {
        for (let t in videoQueueRecordStatus) {
          if (videoQueueRecordStatus[t] === cell) {
            return t;
          }
        }
      },
    },
    {
      dataField: "woo_store_video_status",
      text: "Site Display Status",
      formatter: (cell) => {
        if (cell === "Live") {
          return (
            <span className="m-badge mx-auto my-0 px-2 m-badge--success">
              <strong>Live</strong>
              <i
                className="fa fa-circle fa-sm m--font-danger"
                style={{ marginLeft: 5 }}
                aria-hidden="true"
              ></i>
            </span>
          );
        } else if (cell === "Not-Live") {
          return (
            <span className="m-badge mx-auto my-0 px-2 m-badge--accent">
              <strong>Not Yet Live</strong>
            </span>
          );
        } else {
          return (
            <span className="m-badge mx-auto my-0 px-2 m-badge--warning">
              <strong>Pending</strong>
            </span>
          );
        }
      },
    },
    {
      dataField: "updatedAt",
      text: "Last Updated",
      formatter: (cell) => moment(cell).format("MM-DD-YYYY, hh:mm A"),
      sort: true,
    },
    {
      dataField: "more_information",
      text: "More Information",
      sort: true,
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
    },
  ];

  refreshVideoQueue = () => {
    this.props.getVideoQueue();
  };

  retryQueueItem = (e, row) => {
    e.preventDefault();

    if (row && row.MedicalRecord) {
      if (row.status === "Failed") {
        this.props.retryVideoQueueItem(row.MedicalRecord.id);
      } else {
        NotificationManager.warning(
          "Selected Task Manager queue item is in a restricted retry state"
        );
      }
    }
  };

  render() {
    const { contentData, cdCompleted, cdDeleting, cdFailed, cdInProgress, cdWaiting } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">Video Manager</h3>
                    </div>
                  </div>
                  <div className="medical-record-button-container">
                    <div className="m-portlet__head-tools breed-delivery-record-btn" />
                    <div className="m-portlet__head-tools breed-delivery-record-btn" />
                    <div className="m-portlet__head-tools breed-delivery-record-btn" />
                    <div className="m-portlet__head-tools breed-delivery-record-btn" />
                    <div className="m-portlet__head-tools breed-delivery-record-btn">
                      <Link
                        to="/woo-store"
                        className="m-nav__link btn btn-light m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                      >
                        <span>
                          <i className="la la-arrow-left"></i>
                          <span>Go Back</span>
                        </span>
                      </Link>
                    </div>
                    <div className="m-portlet__head-tools breed-delivery-record-btn">
                      <a
                        href="#"
                        className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air"
                        onClick={this.refreshVideoQueue}
                      >
                        <span>
                          <i className="la la-refresh"></i>
                          <span>Refresh Video Queue</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "All",
                        })}
                        onClick={() => this.setState({ selectedTab: "All" })}
                      >
                        All
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "In-Progress",
                        })}
                        onClick={() => this.setState({ selectedTab: "In-Progress" })}
                      >
                        In Progress
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Waiting",
                        })}
                        onClick={() => this.setState({ selectedTab: "Waiting" })}
                      >
                        Waiting
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Deleting",
                        })}
                        onClick={() => this.setState({ selectedTab: "Deleting" })}
                      >
                        Deleting
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Failed",
                        })}
                        onClick={() => this.setState({ selectedTab: "Failed" })}
                      >
                        Failed
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Completed",
                        })}
                        onClick={() => this.setState({ selectedTab: "Completed" })}
                      >
                        Completed
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                      <ToolkitProvider
                        keyField="id"
                        data={
                          this.state.selectedTab === "All"
                            ? contentData
                            : this.state.selectedTab === "In-Progress"
                            ? cdInProgress
                            : this.state.selectedTab === "Waiting"
                            ? cdWaiting
                            : this.state.selectedTab === "Deleting"
                            ? cdDeleting
                            : this.state.selectedTab === "Failed"
                            ? cdFailed
                            : this.state.selectedTab === "Completed"
                            ? cdCompleted
                            : {}
                        }
                        columns={this.tableHeaderColumnData}
                        search
                        defaultSortDirection="asc"
                        hover={true}
                        filter={filterFactory()}
                      >
                        {(props) => (
                          <div>
                            <div className="px-0 mb-4 search-bar">
                              <div className="col-lg-3 px-0 inner-addon right-addon">
                                <i className="fas fa-search"></i>
                                <SearchBar {...props.searchProps} />
                              </div>
                            </div>
                            <BootstrapTable
                              classes="petVerticalCenterTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.videoManagerReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getVideoQueue: () => {
    dispatch(getVideoQueue());
  },
  retryVideoQueueItem: (mRecordId) => {
    dispatch(retryVideoQueueItem(mRecordId));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoManager));
